import {Box, Stack, Text, Image} from '@chakra-ui/core';
import React from 'react';
import {darkgrey, yellow} from 'styles/constants';
import {getModelImage} from 'utils/images';

const RecommendedModelSimple = ({
	setSettingsOpen,
	recommendedSleipner,
	moveToSummary,
}) => {
	const modelImageSource = getModelImage(recommendedSleipner.model);

	return (
		<Stack bg={yellow} w={'100%'} mt={6} p={6} rounded={2} alignItems="center">
			<Text fontSize={56} color={darkgrey} fontWeight="bold" mt={-4}>
				{recommendedSleipner?.model ?? '---'}
			</Text>
			<Text fontSize={'lg'} mt={-6}>
				Recommended Sleipner model
			</Text>
			<Box py={8} px={12}>
				<Image
					src={modelImageSource}
					maxW={{base: 300, lg: '100%'}}
					alt="Recommended sleipner model"
				/>
			</Box>
		</Stack>
	);
};

export default RecommendedModelSimple;
